<script setup lang="ts">
import {File, List} from "@lucide/vue";

const mode = defineModel<"prescriptions" | "raw">({required: true});
</script>

<template>
  <div class="grid grid-cols-2 bg-white rounded-full overflow-hidden">
    <div
      class="px-4 py-1 rounded-full cursor-pointer"
      :class="{
        'text-primary font-bold bg-primary/15': mode === 'raw',
      }"
      @click="mode = 'raw'"
    >
      <List class="w-5 h-5 mr-1 text-primary inline-block" />
      <span>Délivrances</span>
    </div>
    <div
      class="px-4 py-1 rounded-full cursor-pointer"
      :class="{
        'text-primary font-bold bg-primary/15': mode === 'prescriptions',
      }"
      @click="mode = 'prescriptions'"
    >
      <File class="w-5 h-5 mr-1 text-primary inline-block" />
      <span>Ordonnances</span>
    </div>
  </div>
</template>

<style scoped>

</style>
